import { useState } from "react";
import CommunityProfileSidebar from "./CommunityProfileSidebar";
import CommunityProfileTabs from "./CommunityProfileTabs";
import CommunityCategories from "./CommunityCategories";
import CommunityGlobalTabs from "./CommunityGlobalTabs";
import CommunityRightSideBar from "./CommunityRightSideBar";

const CommunityProfileScreen = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        padding: "10px",
        height: "85vh",
        backgroundColor: "#F4F7FE",
        overflow: "hidden",
      }}
    >
      <CommunityProfileSidebar />

      <div
        style={{
          width: "45%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CommunityProfileTabs />
      </div>

      <div
        style={{
          width: "30%",
          textAlign: "left",
          margin: "10px",
          display: "flex",
          flexDirection: "column",
          // border: "1px solid red",
        }}
      >
        <div
          style={{
            minHeight: "80vh",
            overflowY: "scroll",
            scrollbarWidth: "none",
            scrollBehavior: "smooth",
          }}
        >
          <CommunityRightSideBar />
          {/* <OnlyMyFeeds /> */}
        </div>
      </div>
    </div>
  );
};

export default CommunityProfileScreen;
